import React from 'react';
import { Header } from './header';
import { Footer } from './footer';
import SignInModal from '../../auth/signInModal';
import { subscribe } from 'react-contextual';
import SelectComponent from "../elements/selectComponent";
import selectPlatform from '../../../util/selectPlatform';
import WGFooter from '../../workplace/WGFooter';
import CheckoutHeader from './header/checkoutHeader';


class SiteChrome extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            toggleModal: false,
            signUpOpen: false,
        };
        const events = {
            on(event, cb, opts) {
                if (!this.namespaces) // save the namespaces on the DOM element itself
                { this.namespaces = {}; }

                this.namespaces[event] = cb;
                const options = opts || false;

                this.addEventListener(event.split('.')[0], cb, options);
                return this;
            },
            off(event) {
                this.removeEventListener(event.split('.')[0], this.namespaces[event]);
                delete this.namespaces[event];
                return this;
            },
        };

        // Extend the DOM with these above custom methods
        if (window) {
            window.on = Element.prototype.on = events.on;
            window.off = Element.prototype.off = events.off;
        }
    }

    toggleSignUpModal = () => {
        this.setState({
            signUpOpen: true,
            toggleModal: !this.state.toggleModal,
        });

        if (window.eventDispatcher) {
            window.eventDispatcher.dispatchEvent('signupClick', {}, { amplitude: true });
        }
    };

    toggleLogInModal = () => {
        this.setState({
            signUpOpen: false,
            toggleModal: !this.state.toggleModal,
        });

        if (window.eventDispatcher) {
            window.eventDispatcher.dispatchEvent('loginClick', {}, { amplitude: true });
        }
    };

    toggleSignUpOpen = () => {
        this.setState({
            signUpOpen: !this.state.signUpOpen,
        });

        const eventInfo = {
            transitionTo: (this.state.signUpOpen) ? 'login' : 'signup'
        };

        if (window.eventDispatcher) {
            window.eventDispatcher.dispatchEvent('switchLoginSignup', eventInfo, { amplitude: true });
        }
    };

    toggleModal = () => {
        this.setState({
            toggleModal: !this.state.toggleModal,
        });

        if (window.eventDispatcher) {
            window.eventDispatcher.dispatchEvent('closeLoginSignupModal', {}, { amplitude: true });
        }
    };

    render() {
        const {
            logo, backgroundColor, session, stickyTop, fixedTop, navHeight, color, pageType, tenantConfig,
            mainStyle, children, width, forceToggle, footerLogo, hideSearch, hideOldplatformStrip, partner,
            stickySecondSubMenu, subdomain, hideLogin, hideMainMenu, loginBackgroundColor, hideOldPlatformLink
        } = this.props;



        let openFlag = this.state.toggleModal;
        if (forceToggle) {
            openFlag = this.state.toggleModal !== this.props.forceToggle;
        }

        return (
            <React.Fragment>

                <div style={this.props.chromeStyle}>

                    {/* {!hideOldplatformStrip && <OldPlatformStrip isProgramPage={this.props.isProgramPage}/>} */}
                    {this.props.source !== 'sqrrl' ? (pageType !== 'checkout' ?

                        <Header
                            session={session}
                            toggleSignUpModal={this.toggleSignUpModal}
                            toggleLogInModal={this.toggleLogInModal}
                            backgroundColor={backgroundColor || 'white'}
                            color={color}
                            logo={logo}
                            stickyTop={stickyTop}
                            fixedTop={fixedTop}
                            navHeight={navHeight}
                            width={width}
                            hideSearch={hideSearch}
                            partner={partner}
                            stickySecondSubMenu={stickySecondSubMenu}
                            hideMainMenu={hideMainMenu}
                            _csrf={this.props._csrf}
                            loginBackgroundColor={loginBackgroundColor}
                            hideOldPlatformLink={hideOldPlatformLink}
                        /> : <CheckoutHeader theme={tenantConfig.theme} />) : <div className="header-for-sqrrl">
                            <style global jsx>
                                {
                                    `
								.header-for-sqrrl {
									width: 100%;
									transform: skewy(-6deg);
									top: -75px;
									left: 0;
									background: #13253b;
									position: absolute;
									height: 160px;
								}

								html {
									overflow-y: scroll;
								}

								body {
									background: #ACAEA9;
									overflow-y: scroll;
								}

										html {
										  overflow-y: scroll;
										}

										body {
										  background: #acaea9;
										  overflow-y: scroll;
										}
									  `}
                            </style>
                        </div>
                    }

                    <main style={mainStyle}>
                        <div>{children}</div>
                    </main>

                    {this.props.source !== "sqrrl" ? (pageType !== 'checkout' ?
                        <SelectComponent name={selectPlatform(subdomain)}>
                            <Footer pageType={pageType} session={session} logo={footerLogo} name={"www"} />
                            <WGFooter name={"wg"} subdomain={subdomain} tenantConfig={tenantConfig} />
                        </SelectComponent>
                        : null) : null}
                </div>

                <SignInModal
                    session={session}
                    isOpen={openFlag}
                    isSignUpOpen={this.state.signUpOpen}
                    toggleModal={this.toggleModal}
                    toggleSignUpOpen={this.toggleSignUpOpen}
                    _csrf={this.props._csrf}
                />
            </React.Fragment>
        );
    }
}

export default subscribe()(SiteChrome);
